module.exports = __webpack_public_path__ + "img/product-4-INTmobile.172448a5.png";